


<template>
 <a-locale-provider :locale="locale">
  <router-view/>
 </a-locale-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import account from './mixins/account'
export default {
  name: 'hp-manager-app',
  mixins: [account],
  data () {
      return {
        locale: zhCN,
      }
    },
}
</script>

<style lang="scss">
@import "assets/scss/output.scss";

</style>




// WEBPACK FOOTER //
// src/App.vue